"use strict";

import CardView from "/js/card-views/card-view.js";
import AppUtil from "/js/util/app-util.js";
import Metrics from "/js/util/metrics.js";

/**
 * A 'normal' lesson card, consisting of an optional image and a text block below it.
 */
export default class NormalCardView extends CardView {
  
  static _WITH_IMAGE_TEMPLATE_STRING = `
      <img class='img' src='<%= image %>' style='height:<%= imageHeight %>px;' alt="">
      <div class='text' style='top:<%=textY %>px; height:<%=textHeight%>;'><%= text %></div>
      <div class='dot'></div>
      `;
  static _withImageTemplate = _.template(NormalCardView._WITH_IMAGE_TEMPLATE_STRING);

  static _NO_IMAGE_TEMPLATE_STRING = `
      <div class='text' style='top:24px; height:<%=textHeight%>;'><%= text %></div>
      <div class='dot'></div>
      `;
  static _noImageTemplate = _.template(NormalCardView._NO_IMAGE_TEMPLATE_STRING);

  makeContent() {
    // Note that text area top and height must be set explicitly (autoshrink requirement).
    // The no-image version is supposed to be vertically centered. Hard because of above. Skipped.

    const hasImage = (this.data.image && this.data.image.url);
    const o = {};
    o.text = CardView.makeHtmlFromJsonTextArray(this.data);
    if (hasImage) {
      o.image = AppUtil.makeLessonAssetPath(this.data.image.url);
      o.imageHeight = this.data.image.height * 8;
      o.textY = 8 + o.imageHeight;
      o.textHeight = (Metrics.cardHeight - o.textY - 40) + "px";
    } else {
      o.textHeight = (Metrics.cardHeight - 40) + "px";
    }

    const s = hasImage ? NormalCardView._withImageTemplate(o) : NormalCardView._noImageTemplate(o);
    return s;
  }
}
